export default "__VITE_ASSET__C48cgpGZ__"